import styled from '@emotion/styled'
import * as v from '../../../variables/styles'

export const PaginationContainer = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 10px;

  .Table__itemCount {
    font-family: 'IBM Plex Sans Thai';
    font-size: 12px;
  }

  .navigateButton, .numberButton {
    height: 33px;
    font-size: 12px;
    font-family: 'IBM Plex Sans Thai';
    display: flex;
    align-items: center;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
    margin-right: 5px;
  }

  .navigateButton {
    color: ${v.ezMainColor};
  }

  .navigateButton:disabled {
    cursor: unset;
    color: ${v.textGray};
  }

  .numberButton {
    width: 33px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 1rem;
    font-family: 'IBM Plex Sans Thai';
    font-weight: normal;
    outline: none;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  .numberButton:disabled {
    cursor: not-allowed;
    color: gray;
  }

  .numberButton.active {
    color: #FFF;
    background: ${v.ezMainColor};
    border-radius: 33px;
    font-weight: bold;
  }

  .prevPageWrapper {

  }

  .visiblePagesWrapper {
    display: flex;
  }

  .nextPageWrapper {

  }

`
